import type {
  CollectionsResponse,
  CollectionList,
  CollectionView,
} from '@/api/types/collections.types';
import type { InfiniteLoaderData } from '@/api/types/common.types';

import { httpClient } from '@/libs/http-client';

export class CollectionsApi {
  static fetchCollections = async (params: { module_id: string; page: number; items?: number }) => {
    const { page, module_id, items = 12 } = params;

    const { data } = await httpClient.get<CollectionsResponse>(
      `/content/collections/list?module_id=${module_id}&page=${page}&items=${items}`,
    );

    const transformedData: InfiniteLoaderData<CollectionList, unknown> = {
      currentPage: data.currentPage,
      lastPage: data.lastPage,
      total: data.total,
      list: data.movieCollections,
    };

    return transformedData;
  };

  // =================================================================

  static fetchCollectionsView = async (params: { id: string; module_id: string }) => {
    const { data } = await httpClient.get<CollectionView>('/content/collections/view', {
      params,
    });

    return data;
  };
}
